import { render, staticRenderFns } from "./scene18.vue?vue&type=template&id=f048dab8&scoped=true&"
import script from "./scene18.vue?vue&type=script&lang=ts&"
export * from "./scene18.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f048dab8",
  null
  
)

export default component.exports